import React, { useEffect } from "react";
import background from "../images/Privacybackground.png";
import Footer from "../components/footer";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import FAQ from '../components/Faq'
import WhiteButton from "../components/WhiteButton";
import { InlineWidget, PopupButton } from "react-calendly";
const ThankYou = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="h-full bg-[#0E101B]">
      <div
        style={{
          backgroundImage: `url(${background})`,
        }}
        className="bg-[#0d121e] h-full bg-cover font-thicboi px-6 md:px-20 py-10"
      >
        <Header />
        <div className='flex flex-col gap-10 items-center w-full pb-20 md:pb-40'>
            <div className="flex flex-col py-20 items-center text-center w-full">
               <div className='md:w-[50%]'>
               <p className=" text-white font-dmSerif italic text-7xl">Book a Demo</p>
               </div>
                <div className="md:w-[70%] flex items-center justify-center ">
                    <p className="text-white text-center font-extralight font-sans">
                    Schedule a 15-min demo with our experts
                    </p>
                </div>
               
            </div>
           
            
            </div>
      </div>
      <div className='bg-[#0E101B] px-6 md:px-20 skew-y-6 py-20 flex w-full -mt-20 overflow-x-clip justify-center flex-col  gap-10'>
        <div className='flex justify-center w-full -skew-y-6'>

<div className='flex flex-col gap-16 px-6 md:px-20 py-12 customBorder2  rounded-md font-thicboi backdrop-filter backdrop-blur-xl aspect-auto -translate-y-32 justify-center' >
    <div className='flex text-white text-center text-2xl flex-col gap-8'>
       <p className="text-2xl text-white">Thank you for booking a demo! </p>
       <p> We’ve received your request and will reach out soon. </p>
       <p>To schedule a time that works best for you, please select a slot now.</p>
    </div>
    <div className='flex items-center justify-center'>
    <div className="flex items-center space-x-4">
    <PopupButton 
    className="py-1 px-3 md:py-3 md:px-6 text-base rounded-lg font-thicboi bg-white text-black"
    url="https://calendly.com/tushar-northstarz" 
    rootElement={document.getElementById("root")}
        text="Scheule a demo"/>
      
    </div>
    </div>
     
    </div>

    
    </div>
    

    <div className='flex flex-col justify-center -skew-y-6 w-full gap-16'>
    <FAQ/>

    </div>

       
        </div>
      
      <Footer />
    </div>
  );
};

export default ThankYou;
